import { useEffect, useState } from "react";
import { Lock } from "lucide-react";

const formatError = (detail) => {
  if (!detail) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return detail.msg || String(detail);
};

const inputCls = "w-full bg-[var(--ec-cream)] border border-[var(--ec-field-border)] rounded-xl px-4 py-3 focus:border-[var(--ec-lake)] focus:ring-2 focus:ring-[var(--ec-lake)]/20 outline-none transition";

export default function AdminLogin({ http, onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    document.title = "Staff sign in | Elk Creek Marina";
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await http.post("/auth/login", { email, password });
      onLogin(data);
    } catch (err) {
      setError(formatError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen bg-[var(--ec-cream)] pb-20" data-testid="admin-login-page">
      <div className="h-20 bg-[var(--ec-navy)]" />
      <form onSubmit={submit} className="max-w-md mx-5 sm:mx-auto mt-12 bg-white rounded-3xl p-8 border border-[var(--ec-sand)] shadow-sm" data-testid="admin-login-form">
        <Lock className="w-6 h-6 text-[var(--ec-lake)]" />
        <h1 className="mt-4 font-display text-3xl text-[var(--ec-navy)]">Staff sign in</h1>
        <label htmlFor="admin-email" className="block mt-6 text-xs uppercase tracking-[0.18em] font-semibold text-[var(--ec-navy)]/80 mb-2">Email</label>
        <input id="admin-email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="admin-login-email" />
        <label htmlFor="admin-password" className="block mt-5 text-xs uppercase tracking-[0.18em] font-semibold text-[var(--ec-navy)]/80 mb-2">Password</label>
        <input id="admin-password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="admin-login-password" />
        <div role="alert" className="min-h-[1.5rem] mt-3 text-sm text-red-700 font-medium" data-testid="admin-login-error">{error}</div>
        <button type="submit" disabled={busy} className="mt-3 w-full bg-[var(--ec-navy)] text-white hover:bg-[var(--ec-lake)] disabled:opacity-60 font-semibold py-3.5 rounded-full transition-colors" data-testid="admin-login-submit">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </main>
  );
}
